// ==================== PAGE LOADER =======================

// $(window).on('load', function() {
//   setTimeout(function() {
//     $('#loader').fadeOut(300);
//   }, 700);
// });
